import accounts from "./accounts";

export const apiAccounts = accounts;
